import styles from "../styles/About.module.scss";
import self from "../assets/self.jpeg";
import WorkTitle from "../components/LandingPage/WorkTitle";
import ConnectionForm from "../components/About/ConnectForm";
import Footer from "../components/Footer/Footer";
import bio from "../data/Bio";
import front from "../assets/imagebackground/Vector 7.svg";
import back from "../assets/imagebackground/Vector 8.svg";

const About = () => {
  return (
    <>
      <div className={styles.aboutname}>
        <h1>
          Hello, I’m
          <span>Riddhi</span>
        </h1>
        <div>
          <p>{bio}</p>
          <div>
            <img src={self} alt="me" />
            <img src={back} alt="back" />
            <img src={front} alt="front" />
          </div>
        </div>
        <WorkTitle title="Let’s Connect !" />
        <ConnectionForm />
      </div>
      <Footer title="Work" />
    </>
  );
};

export default About;
